
// Function to format count numbers (max 3 digits)
export const simplifyNumber = (count: number): string => {
  if (count < 1000) {
    return count.toString();
  } else if (count < 10000) {
    // 1,000 - 9,999: Format as X.XXk (e.g., 3.12k)
    return (count / 1000).toFixed(2) + 'k';
  } else if (count < 100000) {
    // 10,000 - 99,999: Format as XX.Xk (e.g., 31.2k)
    return (count / 1000).toFixed(1) + 'k';
  } else if (count < 1000000) {
    // 100,000 - 999,999: Format as XXXk (e.g., 312k)
    return Math.floor(count / 1000) + 'k';
  } else if (count < 10000000) {
    // 1,000,000 - 9,999,999: Format as X.XXm (e.g., 3.12m)
    return (count / 1000000).toFixed(2) + 'm';
  } else if (count < 100000000) {
    // 10,000,000 - 99,999,999: Format as XX.Xm
    return (count / 1000000).toFixed(1) + 'm';
  } else if (count < 1000000000) {
    // 100,000,000 - 999,999,999: Format as XXXm
    return Math.floor(count / 1000000) + 'm';
  } else if (count < 10000000000) {
    // 1,000,000,000 - 9,999,999,999: Format as X.XXb (e.g., 3.12b)
    return (count / 1000000000).toFixed(2) + 'b';
  } else if (count < 100000000000) {
    // 10,000,000,000 - 99,999,999,999: Format as XX.Xb (e.g., 31.2b)
    return (count / 1000000000).toFixed(1) + 'b';
  } else if (count < 1000000000000) {
    // 100,000,000,000 - 999,999,999,999: Format as XXXb (e.g., 312b)
    return Math.floor(count / 1000000000) + 'b';
  } else if (count < 10000000000000) {
    // 1,000,000,000,000 - 9,999,999,999,999: Format as X.XXt (e.g., 3.12t)
    return (count / 1000000000000).toFixed(2) + 't';
  } else if (count < 100000000000000) {
    // 10,000,000,000,000 - 99,999,999,999,999: Format as XX.Xt (e.g., 31.2t)
    return (count / 1000000000000).toFixed(1) + 't';
  } else {
    // 100,000,000,000,000+: Format as XXXt (e.g., 312t)
    return Math.floor(count / 1000000000000) + 't';
  }
};
